import axios from "axios";
import { system_api } from "../../service/system";
import { apiUrl } from "../../service/runtimeUrl";

const instance = axios.create({
  // 路徑前綴
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  // 超時設定

  timeout: system_api.queryTimeout,
});

// axios 發送 request 以前
instance.interceptors.request.use((config) => {
  try {
    if (config.url.indexOf("googleapis") === -1) {
      let userControl = localStorage.getItem("userControl"),
        user = localStorage.getItem("user");

      if (user || userControl) {
        user = JSON.parse(user);
        userControl = JSON.parse(userControl);
        config.headers["Authorization"] =
          user?.data?.token ?? userControl?.data?.token;
      }
    }
  } catch (e) {}

  return config;
});

// axios 回傳 response 以前
instance.interceptors.response.use(
  (result) => {
    /* 
      status: http status
      data: 回傳資料
    */
    const { status } = result;

    if (status >= 200 && status <= 299) {
      return result;
    } else {
      // api 有回應，但未成功取得資料
      return Promise.reject(result);
    }
  },
  (err) => {
    // api 呼叫錯誤
    return Promise.reject(err);
  }
);

export default instance;
